import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 160px;
  margin-top: 8px;
`;

export const HeaderLabel = styled.div`
  display: flex;
  font-size: 13px;
  color: ${colors.grey5};
`;

export const PercentLabel = styled.div`
  font-size: 19px;
  color: ${colors.grey7};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 8px;
`;

export const DateLabel = styled.div`
  display: flex;
  font-size: 13px;
  color: ${colors.grey7};
`;

export const BarContainer = styled.div`
  height: 24px;
  flex: 1;
  display: flex;
  margin-left: 80px;
`;

export const Bar = styled.div<{ width: string }>`
  background-color: ${(props) => props.color};
  border: 1px solid transparent;
  width: ${(props) => props.width};
  transition: width 1s;
  height: 100%;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
